export default "__VITE_ASSET__DExoLNOn__"